import { Headline, spacing } from '@cambridgeassessment/cambridge-ui';
import styled from 'styled-components';

export const StyledContainer = styled.div`
  margin-top: 25vh;
  display: flex;
  flex-direction: column;
  align-items: center;
`;

export const StyledHeadline = styled(Headline)`
  margin-top: ${spacing.M};
  margin-bottom: ${spacing.tiny};
`;
